import React, { useState, useEffect } from 'react';
import cs from 'classnames';
import { useConfigContext } from '../config-provider';
import IconProfile from '../../icon/react-icon/IconProfile';
import IconProfileRound from '../../icon/react-icon/IconProfileRound';
export var AvatarShape;
(function (AvatarShape) {
    AvatarShape["Circle"] = "circle";
    AvatarShape["Rect"] = "rect";
})(AvatarShape || (AvatarShape = {}));
var AvatarStatus;
(function (AvatarStatus) {
    AvatarStatus["None"] = "none";
    AvatarStatus["Loading"] = "loading";
    AvatarStatus["Success"] = "success";
    AvatarStatus["Error"] = "error";
})(AvatarStatus || (AvatarStatus = {}));
function Avatar(props) {
    var src = props.src, _a = props.shape, shape = _a === void 0 ? AvatarShape.Circle : _a, _b = props.newPlaceholder, newPlaceholder = _b === void 0 ? false : _b, _c = props.alt, alt = _c === void 0 ? '' : _c, _d = props.width, width = _d === void 0 ? 46 : _d, _e = props.height, height = _e === void 0 ? 46 : _e, _f = props.onClick, onClick = _f === void 0 ? function () { } : _f, _g = props.onSuccess, onSuccess = _g === void 0 ? function () { } : _g, _h = props.onError, onError = _h === void 0 ? function () { } : _h, _j = props.className, className = _j === void 0 ? '' : _j;
    var _k = useState(AvatarStatus.Loading), status = _k[0], setStatus = _k[1];
    var _l = useState(''), imageSrc = _l[0], setImageSrc = _l[1];
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-avatar";
    var placeholderImg = newPlaceholder ? React.createElement(IconProfileRound, { style: { width: '100%', height: '100%' }, className: prefixCls + "-avatar-loading" }) : React.createElement(IconProfile, { style: { width: '100%', height: '100%' }, className: prefixCls + "-avatar-loading" });
    useEffect(function () {
        loadAvatar(src);
    }, [src]);
    function loadAvatar(src) {
        if (!src) {
            return;
        }
        setStatus(AvatarStatus.Loading);
        var img = new Image(width, height);
        img.onload = function () {
            setImageSrc(src);
            setStatus(AvatarStatus.Success);
            onSuccess();
        };
        img.onerror = function () {
            setStatus(AvatarStatus.Error);
            onError();
        };
        img.src = src;
    }
    return (React.createElement("div", { className: cs(prefixCls + "-avatar-wrapper", prefixCls + "-avatar-status-" + status, prefixCls + "-avatar-" + shape, {
            new: newPlaceholder
        }, className), style: {
            width: width,
            height: height,
        }, onClick: onClick },
        status !== AvatarStatus.Success && placeholderImg,
        React.createElement("img", { width: width, height: height, src: imageSrc, alt: alt, className: prefixCls + "-image" })));
}
var ForwardRefAvatar = React.forwardRef(Avatar);
export default ForwardRefAvatar;
//# sourceMappingURL=index.js.map